__turbopack_context__.v({
  "Accordion": "Accordion-module__jPraqa__Accordion",
  "AccordionItem": "Accordion-module__jPraqa__AccordionItem",
});
